module.exports = __webpack_public_path__ + "img/convenient.3d452992.svg";